import { Injectable } from '@angular/core';
import { AddressService } from "../address.service";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { TextboxControl } from "../../dynamic-form/textbox-control";
import { DropdownControl } from "../../dynamic-form/dropdown-control";
import { DatepickerControl } from "../../dynamic-form/datepicker-control";
import { CheckboxControl } from "../../dynamic-form/checkbox-control";

@Injectable()
export class CustomerMergeFieldService {

    constructor(
        private addressService: AddressService
    ) { }

    public getFields(): Array<FormControlBase<any>> {
        let fields = new Array<FormControlBase<any>>();

        let firstNameField = new TextboxControl();
        firstNameField.key = 'firstName';
        firstNameField.label = 'First Name';
        firstNameField.order = 1;
        firstNameField.validNoNumber = true;
        fields.push(firstNameField);

        let surnameField = new TextboxControl();
        surnameField.key = 'surname';
        surnameField.label = 'Surname';
        surnameField.order = 2;
        fields.push(surnameField);

        let mobileNumberField = new TextboxControl();
        mobileNumberField.key = 'mobileNumber';
        mobileNumberField.label = 'Mobile Number';
        mobileNumberField.order = 3;
        mobileNumberField.validNumberOnly = true;
        mobileNumberField.required = true;
        mobileNumberField.preventKeys = '\\d';
        fields.push(mobileNumberField);

        let emailField = new TextboxControl();
        emailField.key = 'email';
        emailField.label = 'Email';
        emailField.order = 4;
        emailField.validEmail = true;
        fields.push(emailField);

        let externalIdField = new TextboxControl();
        externalIdField.key = 'externalId';
        externalIdField.label = 'Membership Number';
        externalIdField.order = 5;
        fields.push(externalIdField);

        return fields.sort((a, b) => a.order - b.order);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer-merge-field.service.ts